/**
 * this is pending action item for right menu
 *
 * Created by Heesien on 15/8/18
 */

import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {isEmpty} from '../../utility/utilities'

// component import
import AppLink from '../AppLink'
import AppButton from '../AppButton'


// style import
import './style.scss'

class PendingActionItem extends Component {

    renderLink(link) {

        if (isEmpty(link) || isEmpty(link.url)) return

        const {url, text} = link

        return (
            <AppLink route={url} isExternal={true} className="PendingActionItem__link">
                {text || 'More info'}
            </AppLink>
        )
    }

    render() {

        const {title, link1, link2, show_dismiss, onRemove} = this.props

        return (
            <div className="PendingActionItem">
                <div className="PendingActionItem__text-wrap">
                    <div className="PendingActionItem__title">{title}</div>
                    <div>
                        {this.renderLink(link1)}
                        {this.renderLink(link2)}
                    </div>
                </div>
                {show_dismiss && (
                    <AppButton
                        className="PendingActionItem__button"
                        size="small"
                        color="blue"
                        onClick={onRemove}
                        buttonText="Done" />
                )}
            </div>
        )
    }
}

// define the prop types
PendingActionItem.propTypes = {
    title: PropTypes.string,
    link1: PropTypes.object,
    link2: PropTypes.object,
    show_dismiss: PropTypes.bool,
    onRemove: PropTypes.func,
}

export default PendingActionItem



// WEBPACK FOOTER //
// ./src/components/PendingActionItem/index.js